import React from "react";
import { cn } from "../../lib/utils";

export function StatTile({ label, value, hint, testid, accent, icon: Icon }) {
    return (
        <div
            data-testid={testid}
            className={cn(
                "km-card px-6 py-5 flex flex-col gap-1.5 relative overflow-hidden",
            )}
        >
            <div className="flex items-center justify-between">
                <div className="text-[11px] uppercase tracking-[0.14em] text-muted">{label}</div>
                {Icon && <Icon size={16} className="text-muted" strokeWidth={1.4} />}
            </div>
            <div className="num text-3xl leading-tight text-ink">{value}</div>
            {hint && <div className="text-xs text-muted">{hint}</div>}
            {accent && (
                <div
                    className="absolute right-0 bottom-0 w-14 h-14 rounded-full opacity-[0.06]"
                    style={{ background: accent, transform: "translate(30%, 30%)" }}
                />
            )}
        </div>
    );
}
